import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'dva'
import EditStylesFooter from '../Saved/Footers/EditStylesFooter'
import Loader from '../../Loader'
// import SelectedFeaturesContent from './SelectedFeaturesContent';
import SelectedFeaturesFooter from '../Saved/Footers/SelectedFeaturesFooter'
import SidebarDetailHeader from '../SidebarDetailHeader'
import SidebarBody from '../SidebarBody'
import styles from './SelectedFeatures.module.scss'
import FeatureListItem from '../../FeatureListItem'

function SelectedFeaturesSidebar(props) {
  let footer = null
  if (props.newlySelectedfeatures.length > 0) {
    if (props.isEditingFeature) {
      footer = <EditStylesFooter />
    } else {
      footer = <SelectedFeaturesFooter />
    }
  }

  return (
    <>
      <SidebarDetailHeader title='Selected Content' />

      <div className={styles.headerBox}>
        <div className={styles.countBox}>
          <span>{props.newlySelectedfeatures.length} items selected from the map</span>
        </div>
      </div>

      {props.isLoading ? (
        <div className={styles.loader}>
          <Loader active={true} />
          {props.loaderText}
        </div>
      ) : (
        <SidebarBody>
          <div className={styles.bodyContainer}>
            {props.newlySelectedfeatures.map((nsf, i) => {
              return (
                <FeatureListItem feature={nsf} isSelected={nsf.isSelected} isVisible={nsf.isVisible} key={i} showVisibilityIcon={false} />
              )
            })}
          </div>
        </SidebarBody>
      )}

      {footer}
    </>
  )
}

SelectedFeaturesSidebar.propTypes = {
  isEditingFeature: PropTypes.bool,
  isLoading: PropTypes.bool,
  loaderText: PropTypes.string,
  newlySelectedfeatures: PropTypes.array
}

export default connect(model => {
  const { featuresList, isDeletingItems, isEditingFeature, selectedFeatures } = model.features
  let newlySelectedfeatures = []
  let featureIndex = null
  const loaderText = 'Deleting content...'
  const isLoading = isDeletingItems

  if (selectedFeatures.length === featuresList.length) {
    newlySelectedfeatures = [...featuresList]
  } else {
    for (let sfi = 0; sfi < selectedFeatures.length; sfi++) {
      featureIndex = featuresList.findIndex(fl => fl.uuid === selectedFeatures[sfi])
      if (featureIndex > -1) {
        newlySelectedfeatures.push(featuresList[featureIndex])
      }
    }
  }

  return {
    isEditingFeature,
    isLoading,
    loaderText,
    newlySelectedfeatures
  }
})(SelectedFeaturesSidebar)
